/**
 * AppText - Componente de texto canônico do design-system.
 *
 * Aplica a fonte padrão do app ('Liebling') como PRIMEIRA entrada do array de
 * estilo, deixando qualquer `style` do consumidor sobrescrever — semântica
 * idêntica à do antigo monkey-patch de `Text.render`, porém sem o
 * `cloneElement` por render.
 *
 * Uso (drop-in): trocar a origem do import `Text` de 'react-native' para este
 * arquivo. O JSX `<Text>` permanece inalterado.
 *
 * Para texto animado, crie o componente a partir do `Animated` do próprio
 * arquivo (compatível com react-native OU react-native-reanimated):
 * `const AnimatedText = Animated.createAnimatedComponent(AppText);`
 */
import React, { forwardRef } from 'react';
import { Text as RNText } from 'react-native';

const DEFAULT_FONT = { fontFamily: 'Liebling' };

export const AppText = forwardRef(({ style, ...props }, ref) => (
  <RNText {...props} ref={ref} style={[DEFAULT_FONT, style]} />
));

AppText.displayName = 'AppText';

// Alias para permitir o swap de import sem tocar no JSX (`<Text>` continua igual).
export const Text = AppText;

export default AppText;
